'use client';
const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.fd426993c54cb69b6d6d0dfaae7b67fa.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.3c96de9859c5d022389efe5df81ce76f.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.1cd3b4b982705950f58fc36cd25cbf11.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.49e55dd0d300525e3d0d557116ffc077.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.e03845543873968bbf8b2d9c4621bc76.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.6b1ac7bfe494117c3643df7a1219c77b.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.4e52d9069a843e8ca01301fc7f341565.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.7475c81fefa8ce680a43d4fad6c5cb22.min.css',
        versioned: 'step-indicator.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.2d8fb413fd6907171e8f0fc8ef2af1c2.min.css',
        versioned: 'standard-tile.min.css'
    },
    spinner: {
        hashed: 'spinner.e28c0ae32bd5b461b339d7683cf90c86.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.0feb91face94419dad632ea367c7488f.min.css',
        versioned: 'selection-set.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.12638464b8b6dc6fe50e19fb1a8acf1d.min.css',
        versioned: 'ratings-stars.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.eb0d081bb31e4ea4ed2c329001dde212.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.7bdc0ce1cbae90e66e78a75d8923bfe3.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.f8a6655877534424542efbe757aff0bd.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.45418f279035bd9616aa5013590c541d.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.b46d65e7560bb72bfeff62b34aaf1c48.min.css',
        versioned: 'modal-dialog.min.css'
    },
    listbox: {
        hashed: 'listbox.028084467d06865c2b0a8abe283877d6.min.css',
        versioned: 'listbox.min.css'
    },
    icon: {
        hashed: 'icon.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.393ab9dc32ba1b6be15bf4d30fc3c6d6.min.css',
        versioned: 'grid.min.css'
    },
    fieldSet: {
        hashed: 'field-set.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'field-set.min.css'
    },
    carousel: {
        hashed: 'carousel.25a1ebc1986b870a432d5954c2287a77.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'button.min.css'
    },
    banner: {
        hashed: 'banner.4178cea130b056ca99e517d2fe76a803.min.css',
        versioned: 'banner.min.css'
    },
    avatar: {
        hashed: 'avatar.1f9246f389d891f03fe55ac84d65854a.min.css',
        versioned: 'avatar.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.00a3273f7217a62d93a34326a46dbb05.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.ac4be0f658b6bb02882d99cf438d1f10.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.779003813eaf424e3734ce21c01cbb18.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
